import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import HomePage from '../HomePage/HomePage'
import Header from "../../components/organisms/header";
import Footer from "../../components/organisms/footer";
import ProductsPage from "../ProductsPage/ProductsPage";
import ContactPage from "../ContactPage/ContactPage";

class PageWrapper extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/products">
            <Header />
            <ProductsPage />
            <Footer />
          </Route>
          <Route path="/contact">
            <Header />
            <ContactPage />
            <Footer />
          </Route>
          <Route path="/">
            <Header />
            <HomePage />
            <Footer />
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default PageWrapper